import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';
import BaseModal from './BaseModal';
import BAlert, { bAlertType } from './BAlert';

function ConfirmModal({ text, children, show, ...props }) {
    if (!show) {
        return null;
    }

    return (
        <BaseModal
            className="modal--sm"
            continueText="button.text.confirm"
            closeText="button.text.cancel"
            { ...props }>
            <div className="vertical-align-parent full-height">
                <BAlert type={ bAlertType.WARNING } className="padding-top">
                    <span className="confirm-modal__wrapper text-weight--normal">
                        <Icon icon="error" /> <span className="confirm-modal__text">{ text }</span>
                    </span>
                </BAlert>

                { children }
            </div>
        </BaseModal>
    );
}

ConfirmModal.propTypes = {
    text: PropTypes.any.isRequired,
    children: PropTypes.any,
    show: PropTypes.bool
};

ConfirmModal.defaultProps = {
    show: false,
    titleText: 'confirmation.prompt'
};

export default ConfirmModal;
